import {SprintApi} from '../network/sprint_api';
import {SprintsRepository} from '../persistence/sprints_repository';
import {format} from 'date-fns';

export class SprintCreater {
    constructor(private sprintApi: SprintApi, private sprintsRepository: SprintsRepository) {}

    public async create(
        employeeId: number,
        estimateId: number,
        hours: number,
        isExtra: boolean,
        from: Date,
        till: Date,
    ) {
        const sprints = await this.sprintApi.create(
            employeeId,
            estimateId,
            hours,
            isExtra,
            format(from, 'yyyy-MM-dd'),
            format(till, 'yyyy-MM-dd'),
        );
        this.sprintsRepository.storeMany(sprints);
    }
}
